import { useEffect } from 'react';

// Adiciona a classe "visivel" nos elementos .revelar quando eles entram na tela.
export default function useRevelar() {
    useEffect(() => {
        const elementos = document.querySelectorAll('.revelar');

        if (!('IntersectionObserver' in window)) {
            elementos.forEach((el) => el.classList.add('visivel'));
            return undefined;
        }

        const observador = new IntersectionObserver(
            (entradas) => {
                entradas.forEach((entrada) => {
                    if (entrada.isIntersecting) {
                        entrada.target.classList.add('visivel');
                        observador.unobserve(entrada.target);
                    }
                });
            },
            { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
        );

        elementos.forEach((el) => observador.observe(el));
        return () => observador.disconnect();
    }, []);
}
